<template>
  <router-link tag="li" v-if="router && router.name" :to="router">
    <a href="#">
      <i :class="icon"></i> <span>{{ name }}</span>
      <span v-show="badge" class="pull-right-container bg-transparent">
        <small class="label pull-right" :class="[badge.type==='String'?'bg-green':'label-primary']">{{
            badge.data
          }}</small>
      </span>
    </a>
  </router-link>
  <li :class="getType" v-else>
    {{ isHeader ? name : '' }}
    <a href="#" v-if="!isHeader">
      <i :class="icon"></i> <span>{{ name }}</span>
      <span class="pull-right-container">
        <small v-if="badge && badge.data" class="label pull-right"
               :class="[badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
        <i v-else class="fa fa-angle-left pull-right"></i>
      </span>
    </a>
    <ul class="treeview-menu" v-if="items.length > 0">
      <router-link @click.native="changeMenuItem(item.router.name)" tag="li"
                   :active-class="item.router.name === menu.activeMenu ? 'active' : ''" v-for="(item,index) in items"
                   :data="item" :key="index" :to="item.router" v-if="item.router && item.router.name"
                   v-show="showItem(item)">
        <a>
          <i :class="item.icon"> </i>
          {{ item.name }}
        </a>
      </router-link>
      <li v-else>
        <a>
          <i :class="item.icon"></i>
          {{ item.name }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Utils from '../common/utils'

export default {
  name: 'SlideItem',
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default () {
        return {}
      }
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    router: {
      type: Object,
      default () {
        return {
          name: ''
        }
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      routerName: ''
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'menu'
    ]),
    getType () {
      if (this.isHeader) {
        return 'header'
      }

      return this.type === 'item' ? '' : 'treeview'
    }
  },
  methods: {
    ...mapActions([
      'changeMenu'
    ]),
    changeMenuItem (routerName) {
      this.changeMenu({routerName})
    },
    showItem (item) {
      return Utils.showMenuItem(item)
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SlideItem.vue